const createNewPresentation = (presentation) => {
  let newPresentation = {};
  newPresentation.id = presentation.id;
  newPresentation.name = presentation.name;
  newPresentation.url = presentation.url;
  newPresentation.data = presentation.data;
  newPresentation.cachedquery = presentation.cachedquery;
  newPresentation.username = presentation.username;
  newPresentation.active = presentation.active;
  newPresentation.createdAt = presentation.createdAt;
  newPresentation.updatedAt = presentation.updatedAt;
  newPresentation.expiredAt = presentation.expiredAt;

  return newPresentation;
}

export default createNewPresentation



// WEBPACK FOOTER //
// ./src/utils/presentation.js